import { FC, Fragment } from 'react';
import formRule from '@/libs/antd/rules';
import FormBuilder from '@/components/FormBuilder';
import { Avatar, Col, Row, Select, Space, Typography } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import useQuerySelect from '@/hooks/useQuerySelect';

type Users = {
	id: number;
	firstName: string;
};

type Data = {
	limit: number;
	skip: number;
	total: number;
	users: Users[];
};

const INITIAL_USER: Users = {
	firstName: 'Lee',
	id: 33,
};

const DocPage: FC = () => {
	const selectUsers = useQuerySelect({
		queryKey: ['users'],
		queryFn: async (page, [, q]) => {
			const res = await fetch(
				`https://dummyjson.com/users/search?limit=10&skip=${10 * (page - 1)}&q=${q}`,
			);

			await new Promise((resolve) => {
				setTimeout(() => {
					resolve('');
				}, 500);
			});

			const data = (await res.json()) as Data;

			return data.users.map((user) => {
				return {
					label: user.firstName,
					value: user.id,
				} as DefaultOptionType;
			});
		},
	});

	return (
		<Fragment>
			<Row
				gutter={[24, 24]}
				style={{
					padding: 24,
				}}
			>
				<Col
					span={12}
					offset={6}
				>
					<Space>
						<Select
							{...selectUsers}
							defaultValue={{
								value: INITIAL_USER.id,
								label: INITIAL_USER.firstName,
							}}
							placeholder="Select"
							style={{
								width: 280,
							}}
						/>
					</Space>
				</Col>
				<Col
					span={12}
					offset={6}
				>
					<FormBuilder
						fields={[
							{
								name: 'text',
								type: 'text',
								label: 'Text',
								width: '1/2',
								config: {
									placeholder: 'Insert Text',
								},
								rules: [formRule.required('text wajib di isi')],
							},
							{
								name: 'number',
								type: 'number',
								width: '1/2',
								label: 'Age',
								config: {
									placeholder: 'Insert Age',
								},
							},
							{
								name: 'textarea',
								type: 'textarea',
								label: 'Description',
								config: {
									placeholder: 'Insert Description',
								},
							},
							{
								type: 'divider',
							},
							{
								name: 'date',
								type: 'date',
								label: 'Date of Birth',
								width: '1/2',
								config: {
									placeholder: 'Insert Date of Birth',
								},
							},
							{
								name: 'date_range',
								type: 'date-range',
								label: 'Date Range',
								width: '1/2',
							},
							{
								name: 'time',
								type: 'time',
								label: 'Time',
								width: '1/2',
							},
							{
								name: 'time_range',
								type: 'time-range',
								label: 'Time Range',
								width: '1/2',
							},
							{
								type: 'divider',
							},
							{
								name: 'gender',
								type: 'radio-group',
								width: '1/2',
								label: 'Select Gender',
								config: {
									options: [
										{
											value: 1,
											label: 'Male',
										},
										{
											value: 2,
											label: 'Female',
										},
									],
								},
							},
							{
								name: 'favorite',
								type: 'checkbox-group',
								width: '1/2',
								label: 'Select Hoby',
								config: {
									options: [
										{
											value: 1,
											label: 'Swimming',
										},
										{
											value: 2,
											label: 'Hiking',
										},
										{
											value: 3,
											label: 'Traveling',
										},
									],
								},
							},
							{
								name: 'gender',
								type: 'radio-group',
								width: '1/2',
								label: 'Select Gender',
								config: {
									optionType: 'button',
									options: [
										{
											value: 1,
											label: 'Male',
										},
										{
											value: 2,
											label: 'Female',
										},
									],
								},
							},
							{
								name: 'agree',
								type: 'switch',
								label: 'Agree to Disagree?',
								width: '1/2',
								config: {
									checkedChildren: 'Yes',
									unCheckedChildren: 'No',
								},
							},
							{
								type: 'divider',
							},
							{
								name: 'select',
								type: 'select',
								label: 'Select',
								width: '1/2',
								config: {
									placeholder: 'Select Option',
									options: [
										{ value: 1, label: 'Option One' },
										{ value: 2, label: 'Option Two' },
									],
								},
							},
							{
								name: 'multiselect',
								type: 'select',
								label: 'Multiple Selection',
								width: '1/2',
								config: {
									mode: 'multiple',
									placeholder: 'Select Option',
									options: [
										{ value: 1, label: 'Option One' },
										{ value: 2, label: 'Option Two' },
									],
								},
							},
							{
								name: 'custom_select',
								type: 'select',
								label: 'Custom Select',
								width: '1/2',
								config: {
									placeholder: 'Select Option',
									options: [
										{ value: 1, label: 'User A' },
										{ value: 2, label: 'User B' },
									],
									optionRender(option) {
										return (
											<Space>
												<Avatar size={32}>A</Avatar>
												<div>
													<div>{option.data.label}</div>
													<Typography.Text type="secondary">
														Super Admin
													</Typography.Text>
												</div>
											</Space>
										);
									},
								},
							},
							{
								name: 'autocomplete',
								type: 'auto-complete',
								label: 'Auto Complete',
								width: '1/2',
								config: {
									placeholder: 'Insert keyword',
									options: [
										{
											label: 'Bandung',
											value: '1',
										},
										{
											label: 'Jakarta',
											value: '2',
										},
									],
								},
							},
							{
								name: 'user',
								type: 'record',
								label: 'Referral',
								config: {
									fields: [
										{
											name: 'nama',
											type: 'text',
											width: '1/2',
											label: 'Name',
											config: {
												placeholder: 'Insert Name',
											},
										},
										{
											name: 'lastname',
											type: 'text',
											width: '1/2',
											label: 'Lastname',
											config: {
												placeholder: 'Insert Lastname',
											},
										},
										{
											name: 'bio',
											label: 'Bio',
											type: 'textarea',
											config: {
												placeholder: 'Insert Bio',
											},
										},
									],
								},
							},
							{
								name: 'upload',
								type: 'upload',
								label: 'Upload Media',
								config: {
									multiple: false,
									maxCount: 1,
									accept: 'image/png, image/jpeg, image/jpg',
									customRequest() {},
								},
							},
							{
								name: 'terms',
								type: 'checkbox',
								config: {
									children: 'I Accept End User Agreement',
								},
							},
						]}
					/>
				</Col>
			</Row>
		</Fragment>
	);
};

export default DocPage;
